export default "__VITE_ASSET__D9yau$ou__"